export function canvasDafeDatUrl(canvas: HTMLCanvasElement, type?: string) {
  const copy = document.createElement('canvas')
  const ctx = copy.getContext('2d')!
  copy.width = canvas.width
  copy.height = canvas.height
  ctx.drawImage(canvas, 0, 0)
  return copy.toDataURL(type)
}
